import { Reducer } from 'redux';
import connectTypes, { ConnectActions, IConnectState } from './types';

export const initialState: IConnectState = {
  authenticated: false,
};

const reducer: Reducer<IConnectState> = (state: IConnectState = initialState, action) => {
  const stateCopy: IConnectState = JSON.parse(JSON.stringify(state));
  switch ((action as ConnectActions).type) {
    case connectTypes.USER_AUTHENTICATION_SUCCESS: {
      return { ...stateCopy, authenticated: true, user: action.payload };
    }
    default:
      return stateCopy;
  }
};

export default reducer;
